import { createTheme } from '@material-ui/core'
import { Close, SignalWifiOff } from '@material-ui/icons'
import { makeStyles } from '@material-ui/styles'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { setCardsDataThunk } from '../../../redux/card-reducer'
import { setIsConnected } from '../../../redux/data-reducer'

const theme = createTheme()
const useStyles = makeStyles(()=>({
    wrapper:{
        position:'fixed',
        zIndex:'999999',
        padding:'1rem',
        // height:'20vh',
        backgroundColor:'rgba(0,0,0,0.85)',
        color:'#fff',
        display:'flex',
        top:'0',
        bottom:'0',
        right:'0',
        left:'0',
        justifyContent:'center',
        alignItems:'center',
        textAlign:'center',
        [theme.breakpoints.down('md')]:{
            flexDirection:'column'
        }
        

    },
    icon:{
        fontSize:'3rem!important',
        marginRight:'1rem',
        [theme.breakpoints.down('md')]:{
           
            marginBottom:'1rem'
        },
        // [theme.breakpoints.down('sm')]:{
        //     fontSize:'1.5rem!important'
        // },


    },
    title:{
        fontSize:'2.5rem',
        [theme.breakpoints.down('md')]:{
            fontSize:'2rem'
        },
        [theme.breakpoints.down('sm')]:{
            fontSize:'1.5rem',
        },
        
    },
    top:{
        position:'absolute',
        top:'2rem',
        right:'2rem',
        cursor:'pointer'
    }
}))

const NoNet = (props) =>{

        window.addEventListener('offline',()=>{
            props.setIsConnected(false)
        })
        window.addEventListener('online',()=>{
            props.setIsConnected(true)
        })
        // window.navigator.vibrate(300)
        
        
        useEffect(()=>{
            if (navigator.onLine){
                props.setIsConnected(true)
                if(props.cardTypeData.length<2){
                    props.setCardsDataThunk()
                }
            }
        else{
            props.setIsConnected(false)

        }
    },[navigator.onLine])

    const classes = useStyles()
    if (!props.isConnected){
        return(
            <div className={classes.wrapper}>
                <div className={classes.top}><Close sx={{fontSize:'3rem'}} onClick={()=>{props.setIsConnected(true)}}/></div>
                <SignalWifiOff className={classes.icon}/>
                <div className={classes.title}>Проверьте свое подключение</div>
            </div>
        )

    }
    else return(
        <div className='d-none'>

        </div>
    )
}



const mapStateToProps = (state)=>({
    isConnected: state.data.isConnected,
    cardTypeData: state.cardPage.cardTypeData
})


export default connect(mapStateToProps,{setIsConnected,setCardsDataThunk})(NoNet)